
import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { CraftCalculatorSetupComponent } from './craft-calculator-setup/craft-calculator-setup.component';
import { CraftCalculatorIntroComponent } from './craft-calculator-intro/craft-calculator-intro.component';
import { CraftCalculatorPricesComponent } from './craft-calculator-prices/craft-calculator-prices.component';
import { CraftCalculatorResultsComponent } from './craft-calculator-results/craft-calculator-results.component';
import { CraftCalculatorSellingComponent } from './craft-calculator-selling/craft-calculator-selling.component';
import { CraftCalculatorSpecsComponent } from './craft-calculator-specs/craft-calculator-specs.component';
import { CraftCalculatorShoppingComponent } from './craft-calculator-shopping/craft-calculator-shopping.component';
import { CraftCalculatorPricesOutputsComponent } from './craft-calculator-prices-outputs/craft-calculator-prices-outputs.component';
import { CraftCalculatorLoadSaveComponent } from './craft-calculator-load-save/craft-calculator-load-save.component';

@Component({
  selector: 'app-craft-calculator',
  imports: [
    MatTabsModule,
    CraftCalculatorSetupComponent,
    CraftCalculatorIntroComponent,
    CraftCalculatorPricesComponent,
    CraftCalculatorResultsComponent,
    CraftCalculatorSellingComponent,
    CraftCalculatorSpecsComponent,
    CraftCalculatorShoppingComponent,
    CraftCalculatorPricesOutputsComponent,
    CraftCalculatorLoadSaveComponent
],
  templateUrl: './craft-calculator.component.html',
  styleUrl: './craft-calculator.component.scss',
})
export class CraftCalculatorComponent {}
